// extracted by mini-css-extract-plugin
module.exports = {"borderBox":"BorderBox_borderBox__3R5SF"};